// 拖拽上传页面

import  React from "react";
import { Upload, Typography, message } from "antd";
import { InboxOutlined } from '@ant-design/icons';

const { Dragger } = Upload;
const { Title, Paragraph, Text } = Typography;

const DraggerPage = ({setFile, goToDecodePage}) => {
    // 拖拽行为
    const props = {
        name: 'file',
        deforeUpload: () => {
            return false; // 阻止上传
        },
        onChange(info) {
            const { file } = info;
            const uploadFile = file.originFileObj || file;
            // 验证文件
            if (!uploadFile) {
                message.error('未获取到文件对象');
                return;
            }
            setFile(uploadFile);
            goToDecodePage();
        },
    };

    return (
        <div style={{ width: '100%',  marginTop: 30 }}>
            <Title level={5}>功能说明：</Title>
            <Paragraph>
                <Text>
                    本功能用于.dat配置文件的自动整理与手动编辑，并导出对应编辑后的.dat数据文件。
                </Text>
            </Paragraph>
            <Dragger maxCount={1} accept=".dat" {...props} style={{ width: '100%', marginTop: 80 }}>
                <p className="ant-upload-drag-icon" style={{ marginTop: 60 }}>
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">点击或拖动文件至此区域</p>
                <p className="ant-upload-hint" style={{ marginBottom: 60 }}>
                    支持.dat格式的文件，单次最多上传1个文件。
                </p>
            </Dragger>
        </div>
    );
};

export default DraggerPage;